export enum DefaultView {
  ManagedView = 'MANAGED_VIEW',
  StandardView = 'STANDARD_VIEW',
}

export const defaultViewLabels: Record<DefaultView, string> = {
  [DefaultView.StandardView]: 'Standard View',
  [DefaultView.ManagedView]: 'Managed View',
};

export const isDefaultViewMember = (value: string): value is DefaultView => {
  return Object.values<string>(DefaultView).includes(value);
};

export enum SidebarViewState {
  Expanded = 'EXPANDED',
  Collapsed = 'COLLAPSED',
}

export const isSidebarViewStateMember = (
  value: string,
): value is SidebarViewState => {
  return Object.values<string>(SidebarViewState).includes(value);
};
